import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import { _axios } from '../../utils/axios'; 

const EditExperience = (props) => {
    const [show, setShow] = useState(false);
    const [experienceId, setExperienceId] = useState(props?.data?.user_id);
    const [experienceComment, setExperienceComment] = useState('');
    const [userName, setUserName] = useState('');
    const [status, setStatus] = useState(props?.data?.status);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/users`);
                setUsers(response?.data?.data || []);
                console.log("get user details ", response);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchData();
    }, []);


    useEffect(() => {
        if (props.data) {
            setExperienceId(props.data.experience_id);
            setExperienceComment(props.data.experience_comment || '');
            setStatus(props.data.status);
            console.log('Modal opened with experience_id:', props.data.experience_id);
        }
    }, [props.data]);

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
        console.log('Modal opened with experience_id:', experienceId);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const updateData = {
                experience_id: experienceId,
                experience_comment: experienceComment,
                status: status
            };
            console.log('Submitting update with payload:', updateData);
            const response = await _axios.patch(`${ServerPath}/experience/admin`, updateData);

            console.log('Update response:', response.data);
            handleClose();
            window.location.reload();
        } catch (error) {
            console.error('Error updating experience:', error.response ? error.response.data : error.message);
        }
    };

    return (
        <>
            <Button onClick={handleShow} className="btn-square btn btn-primary mx-2"><i className='icon-pencil-alt'></i></Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Experience</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form id='EditExperienceForm' onSubmit={handleSubmit}> 
                        <Row>
                            <Form.Group as={Col} controlId='formGridExperienceComment'>
                                <Form.Label>Experience Comment</Form.Label>
                                <Form.Control
                                    type='text'
                                    value={experienceComment}
                                    onChange={(e) => setExperienceComment(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} controlId='formGridStatus'>
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={status}
                                    onChange={(e) => setStatus(parseInt(e.target.value))}
                                >
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </Form.Control>
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button form='EditExperienceForm' variant="primary" type='submit'>Update</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};


export default EditExperience;
